import { FlatList, Text, TouchableOpacity, View } from 'react-native'
import { i18n } from '$localization/config.js'
import styles from './styles'

const DropdownComponent = ({
  data,
  isShown,
  borderRadius,
  width,
  top,
  renderList,
  onPress,
  backgroundColor,
  selectedItem,
}) => {
  const defaultContentList = (handlePressButton, buttonName) => {
    const isSelectedButton = selectedItem === buttonName ? '#E5E7EB' : 'white'

    return (
      <View
        style={[
          styles.bottomSheetButtonContainer,
          {
            backgroundColor: isSelectedButton,
          },
        ]}
      >
        <TouchableOpacity
          onPress={() => handlePressButton(buttonName)}
          style={styles.defaultBottomSheetButton}
        >
          <Text style={styles.defaultBottomSheetButtonText}>
            {i18n.t(buttonName).capitalized}
          </Text>
        </TouchableOpacity>
      </View>
    )
  }

  return (
    <View
      style={{
        backgroundColor,
        width,
        position: 'absolute',
        top,
        borderWidth: 0.5,
        borderColor: '#CCCCCC',
        zIndex: 999,
        flex: 1,
        display: isShown ? 'block' : 'none',
        borderRadius,
        overflow: 'hidden',
      }}
    >
      <FlatList
        data={data}
        renderItem={(buttonName) =>
          Boolean(renderList)
            ? renderList(onPress, buttonName.item)
            : defaultContentList(onPress, buttonName.item)
        }
      />
    </View>
  )
}

// DropdownComponent.propTypes = {
//   data: PropTypes.array.isRequired,
//   isShown: PropTypes.bool.isRequired,
//   borderRadius: PropTypes.number,
//   width: PropTypes.number,
//   top: PropTypes.number,
//   backgroundColor: PropTypes.string,
//   renderList: PropTypes.object,
//   onPress: PropTypes.func,
// }

DropdownComponent.defaultProps = {
  borderRadius: 7,
  width: 200,
  backgroundColor: 'white',
  top: 45,
  onPress: () => {},
}

export default DropdownComponent
